export default function Error({ error }) {
	return <div className="profile--error error inter">{error}</div>
}
